import React, { FC, useEffect, useState } from "react";
import { Row, Col, Collapse, Input, Spin, notification } from "antd";
import MemberItems from "@pages/member-details/items";
import { isEmpty, cloneDeep } from "lodash";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";
import InputMask from "react-input-mask";
import { usenextkinInfoStore } from "@stores/nextkinInfoStore";
import "./kin-details.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";
import { CASE_STATUS_INFORMATION_UPDATE, USER_ACTION_MODULE_MEMBER_DETAIL, USER_ACTION_TAB_CONTACT_DETAILS, USER_ACTION_CARD_KINS_INFORMATION, USER_ACTION_LOCATION_SAVE_CHANGES, USER_ACTION_DESCRIPTION_KINS_INFORMATION_SAVE } from "@utils/constants";
import { formatPhoneNumber, milleniumClientCheck } from "@utils/helpers";

const { Panel } = Collapse;

const KinsDetails: FC<any> = (props) => {
  const dataCardId = "31";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])
  const [editFlag, setEditFlag] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [pID, setPID] = useState(Number);
  const kinInfo = usenextkinInfoStore((state) => state.kinInfo);
  const setKinInfo = usenextkinInfoStore((state) => state.setKinInfo);
  const previouskinInfo = usenextkinInfoStore((state) => state.previouskinInfo);
  const setPreviousKinInfo = usenextkinInfoStore((state) => state.setPreviousKinInfo);
  const membersServiceGetCurrentMember =  membersService?.getCurrentMember;
  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CONTACT_DETAILS,
      actionCard: USER_ACTION_CARD_KINS_INFORMATION,
      actionLocation: USER_ACTION_LOCATION_SAVE_CHANGES,
      actionDescription: userActionDescription,
    };
    return props;
  };
  const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
    USER_ACTION_DESCRIPTION_KINS_INFORMATION_SAVE,
    CASE_STATUS_INFORMATION_UPDATE
  );
  useEffect(() => {
    console.log("KinsDetails.useEffect1");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey]);

  useEffect(() => {
    console.log("KinsDetails.useEffect2");
    const cMember = membersServiceGetCurrentMember;
    if (cMember && cMember?.patient_id) {
      let pId = parseInt(cMember?.patient_id);
      setPID(pId);
    }
  }, [membersServiceGetCurrentMember]);
  useEffect(() => {
    console.log("KinsDetails.useEffect3");
    if (props?.data) {
      const data = { ...props?.data };
      delete data.datacardId;
      setKinInfo(data);
      setPreviousKinInfo(data);
    }
  }, [props?.data, setKinInfo, setPreviousKinInfo]);

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const genExtra = (id: any, editFlag: any, showLoader: any, onCancel: any, onUpdateDetails: any, setEditFlag: any) => {
    return(
      <>
        <div onClick={e => e.stopPropagation()} className="editClass">
          {
            milleniumClientCheck() ||
          <CanEdit>
            {editFlag ? (
              <>
                <Spin spinning={showLoader} indicator={<HealthemSpinner/>}>
                  <span
                    style={{ margin: "0 20px" }}
                    className="link clr-n125"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancel();
                    }}
                  >
                    Cancel
                  </span>
                  <span className="link save-next-kins-info-extra" onClick={(e) => {
                    e.stopPropagation();
                    onUpdateDetails();
                    }}>
                    Save Changes
                  </span>
                </Spin>
              </>
            ) : (
              <>
                <span className="link clr-blueLink edit-alignment-next-kins" onClick={(e) => {e.stopPropagation();setEditFlag(true)}}>
                  <i style={{ verticalAlign: "middle", marginRight: 10 }} className="icon icon-edit"></i>
                  Edit
                </span>
              </>
            )}
            </CanEdit>
          }
          </div>
          <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler} pinCardIds={props.pinCardIds} />
        </>
    );
  };

  const onUpdateDetails = () => {
    if (kinInfo?.patientKin1PhoneNumber.indexOf("_") < 0 && kinInfo?.patientKin2PhoneNum.indexOf("_") < 0) {
      setShowLoader(true);
      membersService.updateStatus(membersServiceGetCurrentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully")
        },
        error: (e) => {
          console.log("update status failed for kin information")
        },
      });
      memberDetailsService.submitKinData(pID, kinInfo).subscribe({
        next: (v) => {
          setShowLoader(false);
          setEditFlag(false);
          setPreviousKinInfo(kinInfo);
        },
        error: (e) => {
          setShowLoader(false);
        },
      });
    } else {
      notification.error({
        message: "Error",
        description: "Please Enter Valid Phone Number",
      });
    }
  };

  const onCancel = () => {
    setKinInfo(previouskinInfo);
    setEditFlag(false);
  };

  const emptyValueChecker = (val: any) => {
    return val !== "--" && !isEmpty(val) ? val : "";
  };

  return (
    <>
      <Collapse accordion defaultActiveKey={1} expandIconPosition="right" bordered={false} activeKey={activeCardPanel} onChange={onCollapseChange} className={"next-kins-info-container"}>
        <Panel header="Next of Kin’s Information" key="1" className="title" extra={genExtra(dataCardId, editFlag, showLoader, onCancel, onUpdateDetails, setEditFlag)} style={{ marginBottom: "8px" }}>
          <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
            <Row gutter={48}>
              <Col span={12}>
              {
                milleniumClientCheck() ||
                <Col span={24} className="kin-title">
                  <span>First Member Information</span>
                </Col>
              }
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Name"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin1Name)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin1Name: e.target.value })} />
                      ) : kinInfo?.patientKin1Name ? (
                        kinInfo?.patientKin1Name
                      ) : (
                        props?.data?.patientKin1Name
                      )
                    }
                  />
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Relation"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin1Relation)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin1Relation: e.target.value })} />
                      ) : kinInfo?.patientKin1Relation ? (
                        kinInfo?.patientKin1Relation
                      ) : (
                        props?.data?.patientKin1Relation
                      )
                    }
                  />
                </Col>
                {
                  milleniumClientCheck() ? 
                    <>
                    <Col span={24} className={"col-space-alignment-next-kins"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Phone Number"
                        value={formatPhoneNumber(props?.data?.patientKin1PhoneNumber , "usFormat")}
                      />
                    </Col>
                    <Col span={24} className={"col-space-alignment-next-kins"}>
                      <MemberItems
                        left={12}
                        right={12}
                        name="Mobile Number"
                        value={formatPhoneNumber(props?.data?.patientKin1Address , "usFormat")}
                      />
                    </Col>
                    </>
                  : 
                  <>
                  <Col span={24} className={"col-space-alignment-next-kins"}>
                    <MemberItems
                      left={12}
                      right={12}
                      name="Phone Number"
                      value={
                        editFlag ? (
                          <InputMask
                            mask="+\1 999 999 9999"
                            maskPlaceholder={null}
                            className="ant-input member-item"
                            value={emptyValueChecker(kinInfo?.patientKin1PhoneNumber)}
                            onChange={(e) => setKinInfo({ ...kinInfo, patientKin1PhoneNumber: e.target.value })}
                          />
                        ) : kinInfo?.patientKin1PhoneNumber ? (
                          kinInfo?.patientKin1PhoneNumber
                        ) : (
                          props?.data?.patientKin1PhoneNumber
                        )
                      }
                    />
                  </Col>
                  <Col span={24} className={"col-space-alignment-next-kins"}>
                    <MemberItems
                      left={12}
                      right={12}
                      name="Email Address"
                      value={
                        editFlag ? (
                          <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin1Email)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin1Email: e.target.value })} />
                        ) : kinInfo?.patientKin1Email !== "--" ? (
                          <a className="mail-to-link" href={`mailto:${kinInfo?.patientKin1Email ? kinInfo?.patientKin1Email : props?.data?.patientKin1Email}`}>
                            {kinInfo?.patientKin1Email ? kinInfo?.patientKin1Email : props?.data?.patientKin1Email}
                          </a>
                        ) : (
                          kinInfo?.patientKin1Email
                        )
                      }
                    />
                  </Col>
                  <Col span={24} className={"col-space-alignment-next-kins"}>
                    <MemberItems
                      left={12}
                      right={12}
                      name="Address"
                      value={
                        editFlag ? (
                          <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin1Address)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin1Address: e.target.value })} />
                        ) : kinInfo?.patientKin1Address ? (
                          kinInfo?.patientKin1Address
                        ) : (
                          props?.data?.patientKin1Address
                        )
                      }
                    />
                  </Col>
                  </>
                }
              </Col>
              {
                milleniumClientCheck() || 
              <Col span={12} style={{ paddingTop: "3px" }}>
                <Col span={24} className="kin-title">
                  <span>Second Member Information</span>
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Name"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin2Name)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin2Name: e.target.value })} />
                      ) : kinInfo?.patientKin2Name ? (
                        kinInfo?.patientKin2Name
                      ) : (
                        props?.data?.patientKin2Name
                      )
                    }
                  />
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Relation"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin2Relation)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin2Relation: e.target.value })} />
                      ) : kinInfo?.patientKin2Relation ? (
                        kinInfo?.patientKin2Relation
                      ) : (
                        props?.data?.patientKin2Relation
                      )
                    }
                  />
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Phone Number"
                    value={
                      editFlag ? (
                        <InputMask
                          mask="+\1 999 999 9999"
                          maskPlaceholder={null}
                          className="ant-input member-item"
                          value={emptyValueChecker(kinInfo?.patientKin2PhoneNum)}
                          onChange={(e) => setKinInfo({ ...kinInfo, patientKin2PhoneNum: e.target.value })}
                        />
                      ) : kinInfo?.patientKin2PhoneNum ? (
                        kinInfo?.patientKin2PhoneNum
                      ) : (
                        props?.data?.patientKin2PhoneNum
                      )
                    }
                  />
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Email Address"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin2Email)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin2Email: e.target.value })} />
                      ) : kinInfo?.patientKin2Email !== "--" ? (
                        <a className="mail-to-link" href={`mailto:${kinInfo?.patientKin2Email ? kinInfo?.patientKin2Email : props?.data?.patientKin2Email}`}>
                          {kinInfo?.patientKin2Email ? kinInfo?.patientKin2Email : props?.data?.patientKin2Email}
                        </a>
                      ) : (
                        kinInfo?.patientKin2Email
                      )
                    }
                  />
                </Col>
                <Col span={24} className={"col-space-alignment-next-kins"}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Address"
                    value={
                      editFlag ? (
                        <Input className="member-item" value={emptyValueChecker(kinInfo?.patientKin2Address)} onChange={(e) => setKinInfo({ ...kinInfo, patientKin2Address: e.target.value })} />
                      ) : kinInfo?.patientKin2Address ? (
                        kinInfo?.patientKin2Address
                      ) : (
                        props?.data?.patientKin2Address
                      )
                    }
                  />
                </Col>
              </Col>
              }
            </Row>
            <Row>
              <Col span={6}></Col>
              {/* { props?.data?.patientKin1Address !== "--" && !isEmpty( props?.data?.patientKin1Address) &&<Col span={6}>
              <div>
                <Button
                  type="text"
                  shape="circle"
                  size={"small"}
                  className="map-pointer"
                  icon={<i className="icon icon-plus-circle" />}
                >
                  View in map
                </Button>
              </div>
            </Col>}
            <Col span={6}></Col>
            { props?.data?.patientKin2Address !== "--" && !isEmpty( props?.data?.patientKin2Address ) && <Col span={6}>
              <div>
                <Button
                  type="text"
                  shape="circle"
                  size={"small"}
                  className="map-pointer"
                  icon={<i className="icon icon-plus-circle" />}
                >
                  View in map
                </Button>
              </div>
            </Col> } */}
            </Row>
          </Spin>
        </Panel>
      </Collapse>
    </>
  );
};

export default KinsDetails;
